import Tab from '../Tab';
const TabTable =({list, children, selected='',change=()=>{}, label, foPool})=>{

    return <>
        <Tab list={list} selected={selected} change={change} label={label} foPool={foPool}></Tab>
        {children}
    </>
}
export default TabTable